import { fmtDate } from "@/lib/api";

const FALLBACK = [
  "Ao criar sua conta você concorda em utilizar a plataforma FSCsistemas de acordo com a legislação vigente, sendo responsável pelas informações cadastradas e pelos usuários que criar.",
  "Os dados do seu estabelecimento são armazenados de forma isolada e utilizados apenas para a prestação do serviço, conforme a Lei Geral de Proteção de Dados (LGPD).",
  "O período de teste é de 15 dias. Após o término, as vendas podem ser bloqueadas até a contratação de um plano, mantendo seus dados salvos.",
].join("\n\n");

export function TermsText({ doc }) {
  return (
    <div className="select-text space-y-4" data-testid="terms-text">
      <p className="whitespace-pre-wrap text-sm leading-relaxed text-muted-foreground">{doc?.text || FALLBACK}</p>
      {doc?.version && <p className="border-t pt-3 text-xs font-medium text-muted-foreground" data-testid="terms-version-footer">Última revisão {fmtDate(doc.created_at)} · versão {doc.version}</p>}
    </div>
  );
}
